module.exports = __webpack_public_path__ + "img/ahmed.0894d75e.jpg";